// utils/downloadOlympiadPDF.js

import html2pdf from "html2pdf.js";
import LogoMittsure from "../newLogo2204.PNG";

const downloadOlympiadPDF = (data) => {
  console.log("Generating PDF with data:", data);

  if (!data) return;

  // ✅ Financial Year
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  let fyStartYear;
  let fyEndYear;

  if (month >= 4) {
    fyStartYear = year;
    fyEndYear = year + 1;
  } else {
    fyStartYear = year - 1;
    fyEndYear = year;
  }

  const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

  // ✅ Safe JSON parse
  const parseJSON = (val) => {
    try {
      return JSON.parse(val || "[]");
    } catch {
      return [];
    }
  };

  // ✅ Coordinator mapping
  const getCoordinator = (subject) => {
    const c = data.coordinators?.find(
      (x) => x.subject?.toLowerCase() === subject
    );
    return c ? `${c.name} / ${c.mobile}` : "-";
  };

  // ✅ Student Rows
  // const studentRows = data.studentRegistrationSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studentRows = data.studentRegistrationSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map(
      (row) => `
    <tr>
      <td>${row.class}</td>
      <td>${row.science || ""}</td>
      <td>${row.maths || ""}</td>
      <td>${row.english || ""}</td>
      <td>${row.gk_iq || ""}</td>
      <td>${row.reasoning || ""}</td>
    </tr>
  `
    )
    .join("");
  // ✅ Study Material Rows
  // const studyRows = data.studyMaterialSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studyRows = data.studyMaterialSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map(
      (row) => `
      <tr>
        <td>${row.class}</td>
        <td>${row.science || ""}</td>
        <td>${row.maths || ""}</td>
        <td>${row.english || ""}</td>
        <td>${row.gk_iq || ""}</td>
        <td>${row.reasoning || ""}</td>
      </tr>
    `
    )
    .join("");

  const htmlContent = `
  <div style="padding:2px; font-family: Arial; font-size:12px;">

    <!-- HEADER -->
    <div style="display:flex; justify-content:space-between; align-items:center;">
      <img src="${LogoMittsure}" style="width:150px"/>
      <div>
        <p><b style="font-size:'10px'">Date:</b> ${new Date().toLocaleDateString()}</p>
        <p><b>RNO/SO #:</b> ${data.schoolInfo.rno_id}</p>
      </div>
    </div>

    <p style="text-align:center; font-size:18px; font-weight:600">Mittsure Technologies LLP</p>
    <p style="text-align:center; margin-top:2px; padding:0px;font-size:14px; font-weight:600">MOM Registration Summary (${fiscalYearRange})</p>

    <!-- SCHOOL DETAILS -->
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <td><b>MOM School Code:</b> ${data.schoolInfo.partyId}</td>
        <td><b>District Code:</b> ${data.schoolInfo.schoolDistrict}</td>
      </tr>
      <tr>
        <td><b>School Name:</b> ${data.schoolInfo.schoolName}</td>
        <td><b>State:</b> ${data.schoolInfo.schoolState || "-"}</td>
      </tr>
      <tr>
        <td><b>RM/ARM:</b> ${data.schoolInfo.userName}</td>
        <td><b>RM Contact:</b> ${data.schoolInfo.userMobileNumber}</td>
      </tr>
      <tr>
        <td><b>Registration Type:</b> ${data.schoolInfo.RegistrationType}</td>
        <td><b>Date of Olympiad:</b> ${data.schoolInfo.olympiad_date}</td>
      </tr>
      <tr>
        <td><b>Medium:</b> ${data.schoolInfo.reg_medium_name}</td>
        <td><b>Mode of Payment:</b> ${parseJSON(
    data.schoolInfo.mode_of_payment
  ).join(", ")}</td>
      </tr>
      <tr>
        <td><b>Order Status:</b> ${data.schoolInfo.transactionStatus}</td>
        <td><b>Sci Coordinator:</b> ${getCoordinator("science")}</td>
      </tr>
      <tr>
        <td><b>Maths Coordinator:</b> ${getCoordinator("maths")}</td>
        <td><b>Eng Coordinator:</b> ${getCoordinator("english")}</td>
      </tr>
      <tr>
        <td><b>GK Coordinator:</b> ${getCoordinator("gk_id")}</td>
        <td><b>Reasoning Coordinator:</b> ${getCoordinator("reasoning")}</td>
      </tr>
    </table>
        <p style="margin-top:2px;"><b>Admin Remark:</b> ${data.schoolInfo.adminRemark || "-"}</p>

    <!-- STUDENT REGISTRATION SUMMARY -->
    <h3 style="margin:10px 0 5px 0;">Student Registration Summary</h3>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th>Class</th>
        <th>Science</th>
        <th>Maths</th>
        <th>English</th>
        <th>GK & IQ</th>
        <th>Reasoning</th>
      </tr>
      ${studentRows}
      <tr>
        <td><b>Total</b></td>
        <td colspan="5"><b>${data.registrationTotals.totalRegistrations}</b></td>
      </tr>
    </table>

    <p><b>Total Registration Amount:</b> ₹${data.registrationTotals.totalAmount}</p>

    <!-- STUDY MATERIAL SUMMARY -->

    <h3 style="margin:10px 0 5px 0;">Study Material Summary</h3>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th>Class</th>
        <th>Science</th>
        <th>Maths</th>
        <th>English</th>
        <th>GK & IQ</th>
        <th>Reasoning</th>
      </tr>
      ${studyRows}
      <tr>
        <td><b>Total</b></td>
        <td colspan="5"><b>${data.studyMaterialTotals.totalBooks}</b></td>
      </tr>
    </table>

    <p><b>Total Books Amount:</b> ₹${data.studyMaterialTotals.totalAmount}</p>

    <!-- PAYMENT SUMMARY -->
    <h3 style="margin:10px 0 5px 0;">Payment Summary</h3>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th>Total Registration Amount</th>
        <th>Total Study Material Amount</th>
        <th>Total Payable Amount</th>
        <th>Total Paid Amount</th>
      </tr>
      <tr>
        <td>₹${data.paymentSummary.registrationAmount}</td>
        <td>₹${data.paymentSummary.studyMaterialAmount}</td>
        <td>₹${data.paymentSummary.totalPayableAmount}</td>
        <td>₹${data.paymentSummary.totalPaidAmount}</td>
      </tr>
    </table>

  </div>
  `;

  const element = document.createElement("div");
  element.innerHTML = htmlContent;

  html2pdf()
    .set({
      margin: 5,
      filename: `Olympiad_${data.schoolInfo.rno_id}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(element)
    .save();
};

export default downloadOlympiadPDF;